import React from "react";

/**
 * PulseWordmark — typography-only REFORM PULSE lockup.
 *
 * Deliberately icon-free. "REFORM" in the wordmark colour (off-white/white),
 * "PULSE" in the red accent, with an optional small uppercase tagline
 * "Part of REFORM Group" underneath to reinforce brand architecture.
 *
 * Props:
 *   size        "xs" | "sm" | "md" | "lg"  — controls type scale
 *   showTagline hides/shows the "Part of REFORM Group" line
 *   suffix      appended after PULSE (e.g. "Admin") in mono type
 *   className   extra classes on the outer span
 *   tone        "light" (default — dark bg) | "dark" (for use on light bg)
 */
export default function PulseWordmark({
    size = "md",
    showTagline = true,
    suffix,
    className = "",
    tone = "light",
}) {
    const wordmarkColour = tone === "dark" ? "text-[#07070A]" : "text-[#F2F1ED]";
    const taglineColour = tone === "dark" ? "text-[#07070A]/60" : "text-white/55";

    const wordmarkSize = {
        xs: "text-lg",
        sm: "text-xl md:text-2xl",
        md: "text-2xl md:text-[26px]",
        lg: "text-3xl md:text-4xl",
    }[size];

    const taglineSize = {
        xs: "text-[8.5px]",
        sm: "text-[9px]",
        md: "text-[10px]",
        lg: "text-[11px]",
    }[size];

    return (
        <span className={`inline-flex flex-col leading-[0.95] select-none ${className}`}>
            <span className={`font-display tracking-tight ${wordmarkColour} ${wordmarkSize}`}>
                REFORM<span aria-hidden="true" className="inline-block w-[0.24em]" />
                <span className="text-[#FF2A2A]">PULSE</span>
                {suffix && (
                    <span className="ml-2 align-middle font-mono text-[10px] md:text-[11px] font-normal tracking-[0.22em] uppercase text-white/50">
                        {suffix}
                    </span>
                )}
            </span>
            {showTagline && (
                <span className={`font-mono ${taglineColour} tracking-[0.22em] uppercase mt-1.5 ${taglineSize}`}>
                    Part of REFORM Group
                </span>
            )}
        </span>
    );
}
